import { mapGetters, mapActions } from "vuex";
import { types as Search } from "@/store/search";
import { types as Home } from "@/store/home";
import shareTip from "@/components/shareTip.vue"; //微信分享提示组件
import store from "../../../store";
import { getCookie } from "../../../libs/common";
const getters = mapGetters({
  getSearchHistoryList: Search.HISTORY_KEYWORDS_LIST,
  getPioltCity: Home.IS_PIOLICity,
});
const actions = mapActions({
  setSearchHistoryList: Search.HISTORY_KEYWORDS_LIST,
  getSearchList: Search.SEARCH_LIST,
});
export default {
  name: "searchList",
  components: { shareTip },
  data() {
    return {
      link: `//h5.${this.$uleUrl()}/yxd/community/item/itemPage/`,
      // 搜索接口参数
      query: {
        clientCallType: "H5",
        pageIndex: 1,
        pageSize: 500,
        keyword: "",
        area: "",
      },
      loading: false,
      finished: false,
      isLoad: false,
      freshActType: "",
      finishText: "",
      searchStatus: "0", // 0-未搜索 1-搜索有数据 2-搜索无数据
      isShowHot: true, // 是否显示热门搜索
      isShowHistory: true, // 是否显示历史搜索
      noDataVal: "",
      searchValue: "",
      // 热门推荐
      hotList: [
        "车厘子",
        "方便面",
        "油",
        "巴沙鱼",
        "蘑菇",
        "草鸡蛋",
        "奇异果",
        "红颜草莓",
        "牛油果",
      ],
      // 商品列表
      goodsList: [],
      showTip: false, //微信分享提示
      isNewCustomer: false,
      targetUrl: `https://h5.${this.$uleUrl()}/yxd/community`,
      ylyx_search_type:''
    };
  },
  mounted() {
    this.isNewCustomer =
      localStorage.getItem("isNewCustomer") == 2 ? false : true;
    document.querySelector("body").classList.add("bg-fff");
    this.$once("hook:beforeDestroy", () => {
      document.querySelector("body").classList.remove("bg-fff");
    });
    console.log(getCookie("ispioltCity"));
    if (this.getPioltCity || getCookie("ispioltCity")) {
      this.freshActType = "1";
    }
    if (this.$cookies.get("mall_cookie") || this.$cookies.get("ul_utk")) {
      console.log("已登录");
    } else {
      // this.targetUrl = `${this.targetUrl}${this.$route.fullPath}`;
      // this.$dialog
      //   .confirm({
      //     title: "提示",
      //     message: "请先登录",
      //   })
      //   .then(() => {
      //     if (this.$browser().miniprogram) {
      //       window.wx.miniProgram.navigateTo({
      //         url:
      //           "/pages/authorize?target=" +
      //           encodeURIComponent(this.targetUrl) +
      //           "&type=webView", //跳转非tabBar页面(目前就指非首页index)。参数以路径后面拼接即可
      //       });
      //     } else {
      //       window.location.href = `//m.${this.$uleUrl()}/muser/user/login?target=${encodeURIComponent(
      //         this.targetUrl
      //       )}`;
      //     }
      //   })
      //   .catch(() => {});
    }
  },
  computed: {
    ...getters,
  },
  beforeRouteEnter(to,from,next) {
    next((vm) => {
      vm.ylyx_search_type=from.name=='categoryList'?'分类商品搜索':'通用商品搜索';
    });
  },
  methods: {
    ...actions,
    // 获取搜索结果
    getList() {
      if (this.freshActType == 1) {
        this.query.listingTags = "1784";
      }
      this.getSearchList(this.query).then((res) => {
        this.loading = false;
        setTimeout(() => {
          this.$toast.clear();
        }, 1000);
        if (res.returnCode === "0000") {
          //神策埋点
          let _this=this;
          window.uleStatUtil && window.uleStatUtil.sendSensorTrack('ylyx_SearchButtonClick', {
            ylyx_search_type: _this.ylyx_search_type,
            ylyx_search_keyword: _this.noDataVal,
            ylyx_search_keyword_type: '自然搜索',
            ylyx_search_result_num:res.data.totalCount || 0
          });
          // 无数据
          if (res.data.Listings.length === 0) {
            this.searchStatus = "2";
            this.isShowHot = true;
            this.isShowHistory = true;
            this.query.keyword = "";
            this.finished = true;
          } else {
            this.query.pageIndex++;
            this.goodsList = this.goodsList.concat(res.data.Listings);
            this.goodsList.forEach((item) => {
              // 如果有活动价则显示活动价
              // if(item.promotionDesc){
              // 	item.price = item.promotionDesc.listingPrice
              // }
              //新人且有活动并且在活动时间内的时候展示活动价
              // console.log("搜索数据");
              let now = new Date().valueOf();
              //有新人礼活动且在活动时间内显示活动价格，限时抢购商品直接显示活动期的抢购价
              if (item.promotionDesc) {
                //商品有活动
                let promotionDesc = item.promotionDesc;
                if (
                  now >= promotionDesc.startTime &&
                  now <= promotionDesc.endTime
                ) {
                  //商品在活动期内
                  if (
                    item.promotionIds.indexOf("6202") > -1 ||
                    (item.promotionIds.indexOf("6203") > -1 &&
                      this.isNewCustomer)
                  ) {
                    item.price = parseFloat(promotionDesc.listingPrice).toFixed(
                      2
                    );
                  } else {
                    //显示原价
                    item.price = parseFloat(item.minPrice).toFixed(2);
                  }
                } else {
                  item.price = parseFloat(item.minPrice).toFixed(2);
                }
              } else {
                item.price = parseFloat(item.minPrice).toFixed(2);
              }
            });
            let totalPage = Math.floor(this.pageCount(res.data.totalCount));
            if (this.query.pageIndex > totalPage) {
              this.finished = true;
              this.finishedText = "我已到达底部, 暂无其他数据啦~~";
            } else {
              this.finished = false;
            }
            this.searchStatus = "1";
            this.isShowHot = false;
            this.isShowHistory = false;
          }
        } else {
          this.finished = true;
          this.finishedText = "我已到达底部, 暂无其他数据啦~~";
        }
      });
    },
    // 搜索事件
    onSearch(val) {
      if (val === "") {
        return false;
      } else {
        let _this=this;
        //神策埋点
        window.uleStatUtil && window.uleStatUtil.sendSensorTrack('ylyx_SearchButtonClick', {
          ylyx_search_type: _this.ylyx_search_type,
		      ylyx_search_keyword: val,
		      ylyx_search_keyword_type: '自然搜索'
	      });

        this.$toast.loading({
          duration: 0,
          mask: true,
          message: "加载中...",
        });
        // 存入历史记录
        this.setSearchHistoryList(val);
        this.noDataVal = val;
        // this.query.area = this.getStorage("home", "home.AD_CODE");
        // 获取adcode
        if (this.$browser().miniprogram) {
          this.query.area = this.getStorage("home", "home.AD_CODE_MIN");
        } else {
          this.query.area = this.getStorage("home", "home.AD_CODE");
        }
        this.query.pageIndex = 1;
        this.goodsList = [];
        this.getList();
      }
    },
    // 计算总页数
    pageCount(totalCount) {
      return (totalCount + this.query.pageSize - 1) / this.query.pageSize;
    },
    // 点击搜索
    clickSearch(val) {
      this.query.keyword = val;
      this.onSearch(val);
    },
    // 分享
    share(item) {
      let link = this.link + item.listId;
      this.goodsShare(
        item.listName,
        item.listName,
        link,
        item.defImgUrl,
        item.listId,
        item.price,
        item.price,
        this.freshActType
      );
    },
    // 删除历史记录
    clearHistory() {
      store.commit(Search.HISTORY_KEYWORDS_LIST, []);
    },
  },
};
